import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset-search"
export default class extends Controller {
  static targets = ["input"]
  static values = { selectedId: Number }

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value
      const url = `/admin/ai_tutors/search_assets?query=${encodeURIComponent(query)}&selected_id=${this.selectedIdValue || ''}`

      fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
    }, 300)
  }
}
